import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import {
  authErrorsSelector,
  isLoadingResetPasswordSelector,
  resetPassword,
  setAuthErrors,
  validatePasswordToken,
} from 'src/store/auth';

import { CustomButton, CustomInput, PageLoader, WhiteCard } from 'src/components';

import { LockIcon } from 'src/assets';
import './forgotPasswordConfirm.scss';

export const ForgotPasswordConfirm = () => {
  const { t } = useTranslation('forgotPassword');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = useParams();
  const id = params?.id;

  const formErrors = useSelector(authErrorsSelector);
  const isLoading = useSelector(isLoadingResetPasswordSelector);

  const [formData, setFormData] = useState({
    password: '',
    password_confirmation: '',
  });

  useEffect(() => {
    const payload = {
      payload: {
        id,
      },
      navigate,
    };

    dispatch(validatePasswordToken(payload));
  }, [dispatch, navigate, id]);

  useEffect(() => {
    return () => {
      dispatch(setAuthErrors({}));
    };
  }, [dispatch]);

  const onClickSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      const payload = {
        id,
        payload: formData,
        navigate,
      };

      await dispatch(resetPassword(payload));
    },
    [dispatch, navigate, formData, id],
  );

  const onChangeInput = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event?.target?.value }));

      const copiedErrors = _.cloneDeep(formErrors);

      delete copiedErrors?.[key];

      dispatch(setAuthErrors(copiedErrors));
    },
    [dispatch, formErrors],
  );

  return (
    <div className="forgot-password">
      {isLoading ? <PageLoader /> : null}

      <WhiteCard>
        <img src={LockIcon} alt={LockIcon} />
        <h2>{t('resetPassword')}</h2>
        {/* <h6>{t('forReset')}</h6> */}
        <form className="forgot-password__form">
          <CustomInput
            label={t('auth:password')}
            value={formData?.password}
            onChange={onChangeInput('password')}
            errorMessage={formErrors?.password}
            type="password"
          />
          <CustomInput
            label={t('auth:confirmPassword')}
            value={formData?.password_confirmation}
            onChange={onChangeInput('password_confirmation')}
            errorMessage={formErrors?.password_confirmation}
            type="password"
          />
          <CustomButton title={t('resetPassword')} variant="filled" onClick={onClickSubmit} />
        </form>
      </WhiteCard>
    </div>
  );
};
